import React, {FC} from 'react'

import cn from 'classnames/bind'

import s from './AuthTemplateWrapper.module.scss'
const cx = cn.bind(s)

interface IAuthTemplateWrapperProps {
	className?: string
}

const AuthTemplateWrapper: FC<IAuthTemplateWrapperProps> = ({className, children}) => {
	return <div className={cx('wrapper', className)}>{children}</div>
}

AuthTemplateWrapper.displayName = 'AuthTemplateWrapper'

export default AuthTemplateWrapper
